<template>
  <div>
    <label for="formTypeSelected"
    >Form template
      <font-awesome-icon
        v-if="formType && formType.description"
        :icon="['fas', 'info-circle']"
        id="formTypeInfo"
        class="ml-1"
      />
    </label>
    <b-tooltip
      v-if="formType && formType.description"
      target="formTypeInfo"
      triggers="hover"
      placement="top"
      variant="dark"
    >{{ formType.description }}
    </b-tooltip>
    <multiselect
      id="formTypeSelected"
      v-model="formType"
      :options="formTypes"
      label="text"
      track-by="value"
      placeholder="Please select form template"
    >
    </multiselect>
  </div>
</template>

<script>
import TopSpenderCampaignService from "services/api/topSpenderCampaign.service";

export default {
  name: "FormTypeDropdown",
  props: {
    value: {
      type: [String, Object],
      default: null,
    },
  },
  data() {
    return {
      formType: this.normalizeValue(this.value),
      formTypes: [],
      isLoading: false,
    };
  },
  async created() {
    await this.getFormTypes();
  },
  watch: {
    formType(newValue) {
      this.$emit("setFormType", newValue);
    },
    value(newValue) {
      this.formType = this.normalizeValue(newValue);
    },
    formTypes(newValue) {
      this.$emit("setFormTypes", newValue);
    },
  },
  methods: {
    normalizeValue(val) {
      if (val && typeof val === "object" && Object.keys(val).length === 0) {
        return null;
      }
      return val;
    },
    async getFormTypes() {
      this.isLoading = true;
      try {
        await TopSpenderCampaignService.getListFormTypes()
          .then(async (res) => {
            const data = await res.data;
            this.formTypes = data.formTypes.map((s) => {
              return {
                value: s.value,
                text: s.displayName,
                description: s.description,
              };
            });
          })
          .catch((err) => {
            console.log("Error: ", err);
          });
      } catch (error) {
        console.log("Error: ", error);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
